import React, { useState, useEffect } from 'react';
import './Avatar.css';

function Avatar({ agentState }) {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(agentState === 'speaking' || agentState === 'thinking');
  }, [agentState]);

  return (
    <div className="avatar-wrapper">
      <div className="avatar-fallback">
        <div className={`avatar-circle ${isActive ? 'active' : ''}`}>
          <div className="avatar-face">
            {agentState === 'speaking' && '🗣️'}
            {agentState === 'listening' && '👂'}
            {agentState === 'thinking' && '🤔'}
            {agentState === 'idle' && '😊'}
          </div>
        </div>
        
        <div className="avatar-placeholder">
          <p className="avatar-label">AI Assistant</p>
          <p className="avatar-note">
            (Visual avatar with synchronized animations)
          </p>
        </div>
      </div>
    </div>
  );
}

export default Avatar;
